import { render, staticRenderFns } from "./MallCategory.vue?vue&type=template&id=6076fac0&scoped=true&"
import script from "./MallCategory.vue?vue&type=script&lang=js&"
export * from "./MallCategory.vue?vue&type=script&lang=js&"
import style0 from "./MallCategory.vue?vue&type=style&index=0&id=6076fac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6076fac0",
  null
  
)

export default component.exports